import { GraduationCap } from 'lucide-react';
import { DivisionPage } from '../components/DivisionPage';
import { CTASection } from '../components/CTASection';

export function TeachAndLearnPage() {
  return (
    <DivisionPage
      accent="accent-teach"
      icon={GraduationCap}
      nameKey="teach.name"
      badgeKey="teach.badge"
      titleKey="teach.heroTitle"
      leadKey="teach.heroLead"
      pitchKey="teach.pitch"
      specs={[
        { labelKey: 'teach.techVoice', valueKey: 'teach.techVoiceV' },
        { labelKey: 'teach.techImage', valueKey: 'teach.techImageV' },
        { labelKey: 'teach.techLang', valueKey: 'teach.techLangV' },
      ]}
      features={[
        { titleKey: 'teach.s1t', descKey: 'teach.s1d' },
        { titleKey: 'teach.s2t', descKey: 'teach.s2d' },
        { titleKey: 'teach.s3t', descKey: 'teach.s3d' },
        { titleKey: 'teach.s4t', descKey: 'teach.s4d' },
      ]}
      shots={[
        { src: '/mock/teach-forest.svg', captionKey: 'teach.shot1' },
        { src: '/mock/teach-word.svg', captionKey: 'teach.shot2' },
        { src: '/mock/teach-space.svg', captionKey: 'teach.shot3' },
      ]}
    >
      <CTASection />
    </DivisionPage>
  );
}
